


































// @ is an alias to /src
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getDefaultAloUser, AloUser } from '@/models/alo/AloUser'
import { directPayloadQuery } from '@/utils/api'
import apiFamily from '@/api/family'
import { AloFamInscription } from '@/models/alo/AloFamInscription'
import moment from 'moment'
import { VuetifyConfirmObject } from '@/plugins/confirm/types'
import { AloInscription } from '@/models/alo/AloInscription'
import { StatusInscription } from '@/enum/StatusInscription'


@Component({
  name: 'ReadInscription',    
   props: {
    famId:{    
      type:Number,  
      default:0
    }
  }
})
export default class ReadInscription extends Vue {
  private famId!:number
  private all = false
  private loading = false
  private inscriptions:Array<AloFamInscription> = []  

  private headers = [               
    { text: 'Cours', value: 'crsDatdebut'},            
    { text: 'Status', value: 'isnStatus',width:140},       
    { text: 'Carte / Abo', value: 'crwId',width:130},       
    { text: 'Piscine', value: 'piscine'},       
    { text: 'Participant', value: 'libelle'},           
    { text: '', value:'actions', width:30, sortable:false,filterable:false}
  ]

  created(){
    if(this.famId > 0) this.loadInscriptions()
  }

  canCancel(item:AloFamInscription) {
    return item.isnStatus == StatusInscription.inscrit && moment.duration(moment(item.crsDatdebut).diff(moment())).asHours() > 4
  }  

  loadInscriptions(){
    this.loading = true
    directPayloadQuery(apiFamily.inscriptions,{famId:this.famId,all:this.all}).then((inscriptions)=>{
      this.inscriptions = inscriptions
    }).finally(()=>{
      this.loading = false
    })
  }

  @Watch("famId")
  onFamIdChanged(newFamId:number){
    if(newFamId > 0) this.loadInscriptions()
  }

  @Watch("all")
  onAllChanged(all:boolean){
    if(this.famId > 0) this.loadInscriptions()
  }

  annuleCours(inscription:AloFamInscription) {
    this.$confirm(`Voulez vous vraiment annuler le cours "${inscription.cours}" pour "${inscription.libelle}" ?`,{title: "Attention"} as VuetifyConfirmObject)
    .then((answer) => {     
       if (answer) {          
        this.loading = true
        directPayloadQuery(apiFamily.annule,inscription.id).then((result)=>{
          this.loadInscriptions()        
        }).catch((error)=>{
          this.$confirm(error,{title: 'Erreur',buttonTrueText:"Fermer",buttonFalseText:""} as VuetifyConfirmObject)
        })
        .finally(()=>{
          this.loading = false          
        })
      } 
    })      
  }


  get configuration(){
    return this.$store.myGetters.configuration
  }
}
